module.exports = __webpack_public_path__ + "static/media/background_pizza.0344809b.jpg";